const list = {
  MuiList: {
    styleOverrides: {
      root: {
        width: '100%',
      },
    },
  },
};

export default list;
